import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rOyakGmCiroBazli } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakGmCiroBazli>,
  rOyakGmCiroBazli
>(ActionSubTypes.API_OYAKGMCIROBAZLILISTE, DefaultInputDataStateModel<pList, rOyakGmCiroBazli>());
